export default __webpack_public_path__ + "d2a98124fa12c56da07d340a6a30c4e5.svg";